import getUrlParameter from "./parameters.js";

function rewriteAddToCartButton() {
  if (!$("body").hasClass("single-product") || $(".product").hasClass("product-type-bundle")) {
    return;
  }

  const $nativeButton = $("button.single_add_to_cart_button");
  if (!$nativeButton.length || $("a.single_add_to_cart_button").length) {
    return;
  }

  const buttonText = $nativeButton.text();
  const productElement = $(".product").attr("id");
  if (!productElement) {
    return;
  }

  var productId = productElement.replace("product-", "");
  var dataId = productId;

  if ($(".variation_id").val() != "0" && $(".variation_id").val() != undefined) {
    productId = $(".variation_id").val();
  }

  const htmlButton =
    '<a href="' +
    window.location.href.split("?")[0] +
    "?add-to-cart=" +
    productId +
    '" class="single_add_to_cart_button button alt" data-id="' +
    dataId +
    '">' +
    buttonText +
    "</a>";

  if ($(".variations_form").length) {
    $(".woocommerce-variation-add-to-cart").append(htmlButton);
  } else {
    $("form.cart").append(htmlButton);
  }

  $nativeButton.remove();
  setProductString();
}

function productAddons() {
  const addons = $(".addon__select");
  const addonsTotal = $(".addons-total");

  rewriteAddToCartButton();

  var uri = window.location.toString();
  if (getUrlParameter("add-to-cart")) {
    if (uri.indexOf("?") > 0) {
      var clean_uri = uri.substring(0, uri.indexOf("?"));
      window.history.replaceState({}, document.title, clean_uri);
    }
  }

  $(document).on("input", ".quantity .qty", function () {
    setProductString();
  });

  $(document).on("input", ".addon-quantity", function () {
    var price = $(this).parent().parent().data("price") * $(this).val();

    $(this)
      .parent()
      .parent()
      .find("td")
      .html(thousandSeperator(price) + " kr");

    $(this).parent().parent().data("total-price", price);

    calcTotalPrice();
    setProductString();
  });

  addons.on("change", function () {
    var addToCart = $("a.single_add_to_cart_button");
    addonsTotal.find("tbody").html("");
    addonsTotal.slideDown();

    addons.each(function () {
      var value = $(this).val();

      if (value != "") {
        var price = $(this).find("option:selected").data("price");
        var name = $(this).find("option:selected").attr("data-name");
        var permalink = $(this).find("option:selected").data("permalink");

        addonsTotal
          .find("tbody")
          .append(
            '<tr class="addons-total__row" data-price="' +
              price +
              '" data-total-price="' +
              price +
              '" data-product="' +
              value +
              '">' +
              "<th>" +
              '<input type="number" min="1" max="100" class="addon-quantity" value="1">' +
              '<a href="' +
              permalink +
              '" target="_blank">' +
              name +
              "</a>" +
              "</th>" +
              "<td>+" +
              thousandSeperator(price) +
              " kr</td>" +
              "</tr>",
          );
      }
    });

    calcTotalPrice();
    setProductString();
  });

  $(".variations select").on("change", function () {
    setTimeout(function () {
      setProductString();
      var variationHtml = $(".woocommerce-variation-price .price").html();
      $(".summary p.price").html(variationHtml);
    }, 100);
  });
}

function thousandSeperator(nStr) {
  nStr += "";
  var x = nStr.split(".");
  var x1 = x[0];
  var x2 = "";
  if (x.length > 1) {
    x2 = x[1].length > 1 ? "." + x[1] : "." + x[1] + "0";
  }
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + " " + "$2");
  }
  x2 = x2.replace(".", ",");
  x2 = x2 ? x2 : "";
  return x1 + x2;
}

function calcTotalPrice() {
  var price = 0;

  $(".addons-total__row").each(function () {
    price = price + parseFloat($(this).data("total-price"));
  });

  $("td.total-price .price").html(
    '<span class="woocommerce-Price-amount amount">' +
      thousandSeperator(price) +
      ' <span class="woocommerce-Price-currencySymbol">kr</span>',
  );
}

function setProductString() {
  const addonsTotal = $(".addons-total");
  const totalRow = $(".addons-total__row");
  const addToCart = $("a.single_add_to_cart_button");
  if (!addToCart.length) {
    return;
  }

  let productString = "";
  let productId = addToCart.data("id").toString();
  let quantity = $(".quantity .qty").val();

  if ($(".variation_id").val() != "0" && $(".variation_id").val() != "" && $(".variation_id").val() != undefined) {
    productId = $(".variation_id").val();
  }

  totalRow.each(function () {
    productString = productString + $(this).data("product") + ":" + $(this).find("input").val() + ",";
  });

  productString = productString + productId + ":" + quantity;

  if (productString === productId) {
    addonsTotal.hide();
  }

  addToCart.attr("href", window.location.href.split("?")[0] + "?add-to-cart=" + productString);
}

export default productAddons;
